module.exports = __webpack_public_path__ + "static/the-emyth-revisited-5f0fafe6b094d70834cf95ba3acada03.jpg";